import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
                <div className="bg-white border border-slate-200 p-8 text-center">
                    <div className="w-10 h-10 mx-auto bg-[#0055ff] text-white flex items-center justify-center rounded-xl mb-3">
                        <ShieldCheck size={18} />
                    </div>
                    <div className="flex items-center gap-2 justify-center text-sm text-slate-600">
                        <Loader2 size={14} className="animate-spin" /> Verificando sesión…
                    </div>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return children;
}
